/**
 * @generated SignedSource<<e631a267fba6a564d5c79bee768feee5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InsightMetricFilterField = "KpiAbsent" | "KpiPresent" | "LabelLift" | "NumberOfAdsAbsent" | "NumberOfAdsPresent" | "SpendAbsent" | "SpendPresent" | "%future added value";
export type InsightV2OrderBy = "AD_SPEND_ABSENT_ASC" | "AD_SPEND_ABSENT_DESC" | "AD_SPEND_PRESENT_ASC" | "AD_SPEND_PRESENT_DESC" | "COUNT_ABSENT_ASC" | "COUNT_ABSENT_DESC" | "COUNT_PRESENT_ASC" | "COUNT_PRESENT_DESC" | "DELTA_ASC" | "DELTA_DESC" | "LABEL_LIFT_ASC" | "LABEL_LIFT_DESC" | "LABEL_NAME_ASC" | "LABEL_NAME_DESC" | "LABEL_TYPE_ASC" | "LABEL_TYPE_DESC" | "RATE_WHEN_ABSENT_ASC" | "RATE_WHEN_ABSENT_DESC" | "RATE_WHEN_PRESENT_ASC" | "RATE_WHEN_PRESENT_DESC" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type LabelType = "DOMINANT_COLOR" | "HEADLINE" | "HOOK_TEXT" | "IMAGE" | "NOUN" | "PHRASE" | "TAG" | "THEME" | "VERB" | "VIDEO" | "%future added value";
export type MetricFilterOperator = "EQ" | "GT" | "GTE" | "LT" | "LTE" | "NE" | "%future added value";
export type ListInsightV2Request = {
  filter: InsightV2Filter;
  orderBy?: InsightV2OrderBy | null;
  pagination?: PaginationInput | null;
};
export type PaginationInput = {
  skip?: number | null;
  take?: number | null;
};
export type InsightV2Filter = {
  brandId: string;
  delta_gt?: number | null;
  delta_lt?: number | null;
  includeAllDates?: boolean | null;
  kpi: KPI;
  labelTypes: ReadonlyArray<LabelType>;
  metrics?: ReadonlyArray<InsightMetricFilter> | null;
  performanceDateRange?: DateRangeInput | null;
  searchQueries?: ReadonlyArray<SearchQuery> | null;
};
export type SearchQuery = {
  fieldKey: string;
  type: string;
  value: string;
};
export type DateRangeInput = {
  end: string;
  start: string;
};
export type InsightMetricFilter = {
  fieldKey: InsightMetricFilterField;
  operator: MetricFilterOperator;
  value: number;
};
export type ClusteringInsightsQuery$variables = {
  input: ListInsightV2Request;
};
export type ClusteringInsightsQuery$data = {
  readonly clusteringInsights: {
    readonly data: ReadonlyArray<{
      readonly id: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"ThemeInsight_InsightV2">;
    }>;
    readonly metadata: {
      readonly dateRange: {
        readonly end: any;
        readonly start: any;
      } | null;
    };
  };
};
export type ClusteringInsightsQuery = {
  response: ClusteringInsightsQuery$data;
  variables: ClusteringInsightsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "InsightV2Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DateRange",
      "kind": "LinkedField",
      "name": "dateRange",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "labelName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClusteringInsightsQuery",
    "selections": [
      {
        "alias": "clusteringInsights",
        "args": (v1/*: any*/),
        "concreteType": "InsightV2List",
        "kind": "LinkedField",
        "name": "listInsightV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InsightV2",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ThemeInsight_InsightV2"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClusteringInsightsQuery",
    "selections": [
      {
        "alias": "clusteringInsights",
        "args": (v1/*: any*/),
        "concreteType": "InsightV2List",
        "kind": "LinkedField",
        "name": "listInsightV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InsightV2",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "delta",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateWhenAbsent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClusteredSublabel",
                "kind": "LinkedField",
                "name": "clusteredSublabels",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "labelLift",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "labelType",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2469a2f3e43600acdc99287b20d12964",
    "id": null,
    "metadata": {},
    "name": "ClusteringInsightsQuery",
    "operationKind": "query",
    "text": "query ClusteringInsightsQuery(\n  $input: ListInsightV2Request!\n) {\n  clusteringInsights: listInsightV2(input: $input) {\n    data {\n      id\n      ...ThemeInsight_InsightV2\n    }\n    metadata {\n      dateRange {\n        start\n        end\n      }\n    }\n  }\n}\n\nfragment ThemeInsight_InsightV2 on InsightV2 {\n  id\n  labelName\n  delta\n  rateWhenAbsent\n  clusteredSublabels {\n    labelName\n    labelLift\n    labelType\n  }\n}\n"
  }
};
})();

(node as any).hash = "d33a958f24734bd89104950d664ca513";

export default node;
